var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.brandLogo,"alt":"logo"}})]),_c('h1',[_vm._v(_vm._s(_vm.$t('m.loginTitle')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }